import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { listPartners } from '../../../actions/brokers';
import Page from '../../../components/Page';

import BlankState from '../../../components/BlankState';
import DataTable from '../../../components/DataTable';

class PremiumDeposit extends Component{

    constructor(props){
        super(props);
        this.state={
            filter:{
                intermediary:''
            }
        }
    }
    componentDidMount(){
        //const { user }= this.props;
        //this.setState({ filter: user.userInfo.company });
        this.props.listPartners();
    }

    render() {
        const { brokers }= this.props;

        return (
            <Page isAdminPage={ true } pageTitle="Premium Deposit">
                <div className="clearfix card">
                    {
                        brokers.partners.length > 0 ?
                        <DataTable 
                        tableId="premium-deposist"
                        columnTitles={ ["Company Logo", "Company Name", "Credit", "Credit Used", "Balance", "Balance (%)","Minimum Premium","Custom Rate?"] }>
                            {
                                 brokers.partners.map((partner, index)=>{
                                    return (
                                        <tr key={ index } >
                                            <td>
                                                    <img 
                                                        src={partner.insurer_logo} 
                                                        className="img-rounded" 
                                                        alt= {partner.insurer_name} />
                                                </td>
                                                <td>{partner.insurer_name}</td>
                                                <td>{partner.credit_line}</td>
                                                <td>{partner.credit_line - partner.credit_balance}</td>
                                                <td>{partner.credit_balance}</td>
                                                <td>{partner.credit_balance_percentage}</td>
                                                <td>{partner.minimum_premium}</td>
                                                <td>
                                                { 
                                                    partner.is_custom_rates ? 
                                                        <span className="label label-success">Yes</span>
                                                    : 
                                                        <span className="label label-danger">No</span>
                                                }
                                                </td>
                                        </tr>
                                    )
                                 })
                            }
                        </DataTable>
                        :
                        <BlankState 
							data={ brokers.partners } 
							dataName="Premium Deposits" 
							isDataLoading={ true } />

                    }
                </div>
            </Page>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
   user: state.user ,
   brokers: state.brokers
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ listPartners }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PremiumDeposit);


// WEBPACK FOOTER //
// ./src/pages/dashboard/agents/PremiumDeposit.js